<template>
<div class="UserResponsesFilterBar">
    <div class="container-fluid ">
		  <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 h-100 margin-Top-3Perc">
          <div class="col-md-1 col-lg-1 margin-left-1Perc font-size-20px">
            Group
          </div>
          <div class="col-md-3 col-lg-3">
              <select class="form-control width-90Perc">
                <option value="-1" >101 Apps:: 101 apps test course Mastering Difficult conversion internal QA Course</option>
                <option value="2">101 Apps ::Course to test course progress[CT 1.0] </option>
                <option value="3">Course Delete Group:: Course to Delete</option>
                <option value="4">Course Delete 2:: Course to Delete two</option>
                <option value="5">Hemant::Hemant API Automation[HB 1.0]</option>
                <option value="6">Hemant::Hemant test course[HB 1.0]</option>
                <option value="7">IPL Pratyush::Course for Pratyush</option>
             </select>                  
          </div>
          <div class="col-md-1 col-lg-1 font-size-20px">
            Cohort
          </div>
          <div class="col-md-1 col-lg-1 padding-Left-0px padding-right-0px">
              <select class="form-control width-90Perc">
                <option value="-1" >Delhi</option>
              </select>                  
          </div>
          <div class="col-md-1 col-lg-1 font-size-20px">
            Challenge
          </div>
          <div class="col-md-3 col-lg-3 margin-left-1Perc">
              <select class="form-control width-90Perc">
                <option value="-1">Asia Can't Deliver</option>
                <option value="2">Your Team Underperforms</option>
             </select>                  
          </div>
          <div class="col-md-1 col-lg-1">  
            <button type="button" class="btn black-border custom-btn white-BG">Show</button>
          </div>
      </div> 
      <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-right-0px padding-left-0px">
        <!-- <manage-Group-Course-Details></manage-Group-Course-Details> -->
      </div> 
    </div>
  </div>
</template>

<script>
// import UserResponsesFilterBar from '@/components/UserResponsesFilterBar'
export default {
  data: function () {
    return {

    }
  },
  components: {
    // 'User-Responses-FilterBar': UserResponsesFilterBar
  },
  name: 'UserResponsesFilterBar'
}
</script>

<style scoped>
.UserResponsesFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UserResponsesFilterBar.vue